import { BaseService, RequestType } from "@intech/react-service";
import { SimuladorBeneficioCodeprevDados } from "../entidades";

class SimuladorCodeprev extends BaseService {

  constructor() {
    super("SimuladorCodeprev");
  }

  Simular(dados: SimuladorBeneficioCodeprevDados) {
    return this.CreateRequest<any>(RequestType.POST, "Simular", dados);
  }
}

export const SimuladorCodeprevService = new SimuladorCodeprev();